export default "__VITE_ASSET__1be77c43__"